import { banco } from '../db/banco'
import { agoraISO } from '../db/tipos'
import { gravarLocalEEnfileirar } from '../sync/outbox'

// Apaga (soft-delete) o pedido, os sub-pedidos dele e os itens desses subs.
//
// Tudo ou nada numa transacao unica: sem isso, uma falha no meio deixaria
// sub-pedidos orfaos apontando para um pedido que sumiu da lista. O escopo
// externo PRECISA incluir banco.outbox -- gravarLocalEEnfileirar abre
// transacao sobre (tabela + outbox), e transacao aninhada do Dexie so funciona
// quando o escopo externo cobre todas as tabelas internas.
//
// Ja apagado nao e reenfileirado: dois toques no botao nao podem dobrar a fila.
//
// So o pedido ABERTO pode ser excluido (regra de negocio que antes so existia
// no comentario da tela, TelaPedido.tsx). Pedido fechado tem
// lancamentos_comissao que este cascade NAO apaga -- cascatear um pedido
// fechado deixaria uma linha de comissao fantasma em Comissoes.tsx (o
// `irmaos` la filtra o sub-pedido recem-apagado e a letra fica undefined).
export async function excluirPedidoEmCascata(pedidoId: string): Promise<void> {
  await banco.transaction(
    'rw',
    [banco.pedidos, banco.sub_pedidos, banco.itens_pedido, banco.outbox],
    async () => {
      const pedido = await banco.pedidos.get(pedidoId)
      if (!pedido || pedido.apagado_em !== null || pedido.status !== 'aberto') return

      const subPedidos = await banco.sub_pedidos
        .where('pedido_id').equals(pedidoId)
        .filter((s) => s.apagado_em === null)
        .toArray()

      for (const sub of subPedidos) {
        const itens = await banco.itens_pedido
          .where('sub_pedido_id').equals(sub.id)
          .filter((i) => i.apagado_em === null)
          .toArray()
        for (const item of itens) {
          await gravarLocalEEnfileirar('itens_pedido', { ...item, apagado_em: agoraISO() })
        }
        await gravarLocalEEnfileirar('sub_pedidos', { ...sub, apagado_em: agoraISO() })
      }

      await gravarLocalEEnfileirar('pedidos', { ...pedido, apagado_em: agoraISO() })
    },
  )
}
